import { getUser } from 'core/utils';
import { useState, useEffect } from 'react';
import humps from 'humps';

const useCustomer = () => {
	const [loaded, setLoaded] = useState(false);
	const [user, setUser] = useState({});

	useEffect(() => {
		const fetchedUser = getUser();

		if (fetchedUser?.id) {
			const camelizedUser = humps.camelizeKeys(fetchedUser);
			setUser(camelizedUser);
		}

		// with or without user, let consumers know its ready to use
		setLoaded(true);
	}, [setUser]);

	return [user, loaded];
};

export default useCustomer;
